import { render, staticRenderFns } from "./InputChip.vue?vue&type=template&id=185d363e&scoped=true&"
import script from "./InputChip.vue?vue&type=script&lang=js&"
export * from "./InputChip.vue?vue&type=script&lang=js&"
import style0 from "./InputChip.vue?vue&type=style&index=0&id=185d363e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d363e",
  null
  
)

export default component.exports